// A diagram box on a slide (SD): its points laid out (shared/slideDiagram.ts) and drawn as the boxes they make, inside
// its frame, with the board's own box drawing, so it looks the same in every place a slide shows and the same after
// "Convert to boxes". Its parts answer a click as the diagram (they carry its id), so it moves and resizes as one box.

import { useMemo } from "react";
import { layoutDiagram, DIAGRAM_HINTS } from "../../../../shared/slideDiagram";
import type { SlideBox } from "../../../../shared/slideDesign";
import { BoxView, type BoxCtx } from "../Boxes";

export function DiagramBody({ box: b, ctx }: { box: SlideBox; ctx: BoxCtx }) {
  const d = b.diagram!;
  const parts = useMemo(() => layoutDiagram(d, b.w, b.h), [d, b.w, b.h]);
  if (!parts.length)
    return ctx.mode === "edit" ? (
      <div className="sd-dg-empty">
        <b>Type your points</b>
        <span>{DIAGRAM_HINTS[d.kind]}</span>
      </div>
    ) : null;
  const inner: BoxCtx = { ...ctx, editorFor: undefined, layer: (z) => z + 1, build: undefined, buildTag: undefined };
  return (
    <>
      {parts.map((p, i) => (
        <BoxView key={i} box={{ ...p, id: b.id, ...(b.font && !p.font ? { font: b.font } : {}) }} ctx={inner} />
      ))}
    </>
  );
}
